import React from "react";
import ChevronDown from "src/icons/ChevronDown";
import { Stack, styled } from "@mui/material";

export const CellWithArrow = ({ children }) => (
  <StyledChipContainer>
    {children}
    <ChevronDown color="#2D2C44B2" className="list-arrow-down" />
  </StyledChipContainer>
);

const StyledChipContainer = styled(Stack)`
  position: relative;
  width: 100%;
  padding-right: 24px;
  & svg {
    position: absolute;
    right: 2px;
    top: 50%;
    transform: translateY(-50%);
    display: none;
  }
`;
